module.exports = __webpack_public_path__ + "img/holstee.281705b7.jpg";